import * as HttpService from "../../../../service/HttpService"
import 'whatwg-fetch';
import cookie from "react-cookies";
import {message} from "antd";


/** 运行监控  -> 工况查询服务 **/

/**
 *  获取工况列表---已废弃--配电
 * @param parentOrgNo 父单位编号
 */
export const getWorkConditionList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/commCondition/getCommConditionVoList", params);
}

/**
 * 获取表记列表
 * @param devId 终端id
 * @param pageNumber 页号
 */
export const getMeterInfoList = (devId, pageNumber,ceResId) => {
    return HttpService.post(HttpService.DOMAIN + "/commCondition/getMeterOnlineAndOfflineList", {devTermId: devId, current: pageNumber,ceResId:ceResId})
}
